// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.collapsible-item[data-v-1b5adac8] {
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}
.collapsible-header[data-v-1b5adac8] {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  cursor: pointer;
  width: 100%;
}
.collapsible-icon[data-v-1b5adac8] {
  font-weight: bold;
  font-size: 1.1rem;
}
.section-icon[data-v-1b5adac8] {
  font-size: 1rem;
}
.collapsible-text[data-v-1b5adac8] {
  flex: 1;
  font-weight: 500;
}
.chevron-icon[data-v-1b5adac8] {
  color: #555;
}

/* Created - Green */
.collapsible-item.created[data-v-1b5adac8] {
  background-color: #d4edda;
}
.collapsible-item.created .collapsible-icon[data-v-1b5adac8] {
  color: #28a745;
}

/* Substituted - Orange */
.collapsible-item.substituted[data-v-1b5adac8] {
  background-color: #ffe5d0;
}
.collapsible-item.substituted .section-icon[data-v-1b5adac8] {
  color: #fd7e14;
}

/* Ignored - Light yellow */
.collapsible-item.ignored[data-v-1b5adac8] {
  background-color: #fff3cd;
}
.collapsible-item.ignored .section-icon[data-v-1b5adac8] {
  color: #856404;
}

/* Deleted - Red */
.collapsible-item.deleted[data-v-1b5adac8] {
  background-color: #f8d7da;
}
.collapsible-item.deleted .section-icon[data-v-1b5adac8] {
  color: #dc3545;
}
.tooltip-icon[data-v-1b5adac8] {
  color: #6c757d;
  font-size: 0.9rem;
  cursor: help;
}
.collapsible-content[data-v-1b5adac8] {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 15px 16px;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
}
.items-list[data-v-1b5adac8] {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.detail-item[data-v-1b5adac8] {
  padding-left: 8px;
}
.no-items[data-v-1b5adac8] {
  margin: 0;
  color: #666;
  font-style: italic;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
